<template>
  <component
    :is="navigateOnSelect ? 'internal-or-external-link' : 'div'"
    :href="navigateOnSelect ? siteHref : null"
    data-test-id="site-selector-card"
    @click="trackOrSelectSiteSelection()"
  >
    <q-card class="site-selector-card">
      <q-card-section
        class="no-padding"
        :horizontal="!navigateOnSelect"
      >
        <q-card-section
          v-if="!navigateOnSelect"
          class="no-padding"
        >
          <q-checkbox
            v-model="checked"
            class="q-mr-sm"
            @click="selectSiteSelection"
          />
        </q-card-section>
        <q-img
          :src="site.siteThumbnailImageUrl"
          :alt="`picture of ${site.name}`"
        />
        <q-card-section class="column q-pa-none">
          <div
            class="text-h6 text-center q-pa-sm"
            :class="cardColorCss"
            :style="{ 'background-color': cardColor === 'custom' ? cardColorHex : undefined }"
          >
            {{ site.name }}
            <q-item-label
              v-if="site.addressShort"
              class="text-subtitle2 q-py-sm"
            >
              {{ site.addressShort }}
            </q-item-label>
          </div>
        </q-card-section>
      </q-card-section>
    </q-card>
  </component>
</template>

<script>
import InternalOrExternalLink from 'src/modules/consumer/components/InternalOrExternalLink'
import SiteSelectorLinkMixin from 'src/modules/consumer/components/mixins/SiteSelectorLinkMixin'

export default {
  name: 'SiteSelectorCard',
  components: {
    InternalOrExternalLink
  },
  mixins: [SiteSelectorLinkMixin],
  props: {
    site: {
      type: Object,
      required: true
    },
    cardColor: {
      type: String,
      required: false,
      default: 'primary'
    },
    cardColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    redirectHomePage: {
      type: Boolean,
      required: false,
      default: false
    },
    navigateOnSelect: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedLocations: {
      type: Array,
      required: false,
      default: () => []
    }
  }
}
</script>

<style scoped>
.site-selector-card {
  color: inherit;
  display: block;
  text-decoration: none;
}
</style>
